import React from 'react'
import { Modal, App } from 'antd'
import { useAppStationDelMutation } from '../../store/ReactWebSiteApi';

function PostDel(props) {
    const { message } = App.useApp();    
    const {confirm} = Modal; 
    const [submitDel] = useAppStationDelMutation()   
    return (
        <>
            {props.ess_state==='2' && <a onClick={() => {
                if(props.num==='0'){
                    confirm({
                        title: '确认删除该岗位吗？',
                        okText: '确认',
                        okType: 'danger',
                        cancelText: '取消',
                        onOk() {
                            submitDel({
                                ess_id:props.ess_id,
                                ess_state:'2'
                            }).then((res) => {
                                if (res.data.Status === 'success') {
                                    message.info('删除成功！');
                                }
                                if (res.data.Status === "fail") {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        },
                        onCancel() {
                        console.log('Cancel');
                        },
                    })
                }else{
                    message.error('该岗位有用户，不能删除！')
                }
            }}>删除</a>}
             {props.ess_state==='1'&&<a onClick={() => {
                                confirm({
                                    title: '确定取消删除？',
                                    content: props.ed_name,
                                    okText: '确认',
                                    okType: 'danger',
                                    cancelText: '取消',
                                    onOk() {
                                        submitDel({
                                            ess_id:props.ess_id,
                                            ess_state:'1',
                                        }).then((res) => {
                                            console.log(res);
                                            if (res.data.Status === 'success') {
                                                message.info('取消删除成功！');
                                            }
                                            if (res.data.Status === "fail") {
                                                message.error('取消删除失败！'+res.data.Message)
                                            }
                                        })
                                    },
                                    onCancel() {
                                    console.log('Cancel');
                                    },
                                });
                            }}>取消删除</a>}
        </>
    )
}

export default PostDel